import React from 'react';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { ToolButton } from '../../../../components';
import { IToolButtonProps } from '../../../../interfaces';
import { getCurrentData, publish, useSubscription } from '../../../../hooks';
import { AlertTypeEnum, StateTopicEnum } from '../../../../enums';
import { AwardsItemProps } from '..';
import { hideAlert, showAlert } from '../../../../components/alert/Alert';
import { UserPermissions } from '../../../../../src/definitions';
import { securityService } from '../../../../../src/_global/services';

export default function SaveButton({ config, item }: IToolButtonProps) {
  const { id: moduleId, services } = config;
  const { _id: itemId } = item;
  const [invalid, setInvalid] = React.useState(true);
  const [userEditItem, setUserEditItem] = React.useState(item);

  useSubscription(StateTopicEnum.IsValid, (valid: boolean) =>
    setInvalid(!valid)
  );

  useSubscription(StateTopicEnum.EditItem, (editItem: AwardsItemProps) =>
    setUserEditItem(editItem)
  );

  const handleClick = async () => {
    const copy = { ...userEditItem };

    delete copy['listMainPrograms'];
    delete copy['listLinkedPrograms'];

    const { data, success, message }: any = await services.update?.({
      ...copy,
      key: itemId
    });

    if (success) {
      const pageNo = getCurrentData(StateTopicEnum.LibraryPage);
      const searchTerm = getCurrentData(StateTopicEnum.LibrarySearch);
      publish(StateTopicEnum.LibrarySearchAndPage, {
        page: pageNo,
        search: searchTerm
      });
      publish(StateTopicEnum.Refresh, new Date());
      return true;
    } else {
      showAlert({
        content: message,
        options: {
          actions: [{ text: 'Okay', onClick: hideAlert, primary: true }],
          type: AlertTypeEnum.Error
        }
      });
    }
  };

  return (
    <ToolButton
      text='Save'
      icon={faSave}
      path={`/${moduleId}/${itemId}`}
      primary
      raised
      onClick={handleClick}
      invalid={
        invalid || !securityService.checkRoleAccess(UserPermissions.editAwards)
      }
    />
  );
}
